import { facebookPattern } from "../../const/regexPatterns";

export function validateFacebookUrl({
  facebookUrl,
  maxLength = 200,
  fieldName = "Facebook URL",
  required = true
}: {
  facebookUrl: string;
  maxLength?: number;
  fieldName?: string;
  required?: boolean;
}): string | undefined {
  if (!facebookUrl) {
    if (required) return `${fieldName} is required.`;
    return undefined;
  }
  if (facebookUrl.length > maxLength) {
    return `${fieldName} must not exceed ${maxLength} characters.`;
  }
  if (!facebookPattern.test(facebookUrl)) return `Invalid ${fieldName} (must start with https://facebook.com)`;
}
